import { faCloudArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { formatDistanceToNow } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { withIcon } from '../../../../core/components/Icon.tsx';
import { SourceSyncInfo } from '../config/ConfigSteps.tsx';

const SyncStatusIcon = withIcon(faCloudArrowDown);

export const SourceSyncStatusLine = ({ config }: { config?: SourceSyncInfo | null }) => {
    const { t } = useTranslation('assistants', { keyPrefix: 'agentConfig' });

    if (!config?.syncStatus) return null;

    if (config.syncStatus === 'failed') {
        return (
            <div className="flex items-center gap-1.5 text-xs text-content-danger-strong">
                <SyncStatusIcon />
                <span>
                    {t('toolProviders.syncFailing')}
                    {config.syncError ? `: ${config.syncError}` : ''}
                </span>
            </div>
        );
    }

    return (
        <div className="flex items-center gap-1.5 text-xs text-content-medium">
            <SyncStatusIcon />
            <span>
                {config.syncStatus === 'synced' && config.lastSyncedAt
                    ? t('form.lastSynced', {
                          time: formatDistanceToNow(new Date(config.lastSyncedAt), { addSuffix: true }),
                      })
                    : t('toolProviders.syncPending')}
            </span>
        </div>
    );
};
